export default {
    'Онлайн': 'Онлайн',
    'Бесплатные': 'Бекер',
    'ООО «НУР Телеком». Все права защищены': '«НУР Телеком» ЖЧКсы. Бардык укуктар корголгон',
    'Лицензии ГАС при ГКИТиС КР': 'КР SCITC боюнча SAS лицензиялары',
    'ООО «НУР Телеком»: №16-0062-КР от 06.12.2016, №16-0063-КР от 06.12.2016, №14-1124-КР от 03.12.2014': '«НУР Телеком» ЖЧКсы: 12.06.2016-ж. № 16-0062-КР, 06.12.2016-ж. № 16-0063-КР, 03.12.2014-ж. № 14-1124-КР.',
    'Предоставление всех услуг связи регламентируется договором о предоставлении услуг связи ООО «НУР Телеком»': 'Бардык байланыш кызматтарын көрсөтүү NUR Telecom ЖЧКсынын байланыш кызматтарын көрсөтүү келишими менен жөнгө салынат.',
    'Услуга «Игротека» предоставляется совместно с ОсОО «Гамма Технолоджи. Лицензия №17-0192-КР от 4.08.2017': 'Оюн китепканасы кызматы Gamma Technology LLC менен биргеликте көрсөтүлөт. 2017-жылдын 4-августунда №17-0192-КР лицензиясы',
    
    '«O!»™, ООО «НУР Телеком». Все права защищены<br>Лицензии ГАС при ГКИТиС КР:<br>ООО «НУР Телеком»: №16-0062-КР от 06.12.2016, №16-0063-КР от 06.12.2016, №14-1124-КР от 03.12.2014<br><br>Предоставление всех услуг связи регламентируется договором о предоставлении услуг связи ООО «НУР Телеком».<br><br>Услуга «Игротека» предоставляется совместно с ОсОО «Гамма Технолоджи. Лицензия №17-0192-КР от 4.08.2017<br><br>' : '«O!»™, «НУР Телеком» ЖЧК. Бардык укуктар корголгон.  КР МБТМК караштуу МБА лицензиялары:  «НУР Телеком» ЖЧК: 06.12.2016-жылдагы №16-0062-КР, 06.12.2016-жылдагы №16-0063-КР, 03.12.2014 –жылдагы №14-1124-КР<br><br>Бардык байланыш кызматтарынын көрсөтүлүшү «НУР Телеком» ЖЧКсынын байланыш кызматтарын көрсөтүү жөнүндө келишиминин негизинде жөнгө салынат<br><br>«Игротека» кызматы «Гамма Технолоджи» ЖЧК менен биргеликте көрсөтүлөт.  «Гамма Технолоджи» ЖЧК: КР МБТМК караштуу МБА лицензиялары 17-0192-КР от 4.08.2017.<br><br>',
    
    'Правила сервиса': 'Кызмат эрежелери',
    'Настольные игры': 'Үстөл оюндары',
    'Android игры': 'Android оюндары',
    'Онлайн игры': 'Онлайн оюндар',
    'Бесплатные игры': 'Бекер оюндар',
    'Язык': 'Тил',
    'русский': 'Орусча',
    'английский': 'Англисче',
    'Играть': 'Ойно',
    'Скачать игру': 'Оюнду жүктөп алуу',
    'Вызов другу': 'Досуңузду чакырыңыз',
    'Лучшие игроки': 'Мыкты оюнчулар',
    'Играй в любые игры без ограничений на портале ИгрО!тека': 'Igro!teka порталында каалаган оюндарды чектөөсүз ойноңуз',
    'Давай сыграем вместе в': "Келгиле, чогуу ойнойлу",
    'Сотни игр на любой вкус! Играйте онлайн без скачивания на компьютере или телефоне': 'Ар бир табит үчүн жүздөгөн оюндар! Компьютериңизге же телефонуңузга жүктөп албастан онлайн ойноңуз',
    'Уникальная подборка онлайн-игр без регистрации': 'Каттоосуз онлайн оюндардын уникалдуу тандоосу',
    'Лучшие игры на Android во всех жанрах! Качайте и открывайте для себя новый мир игр': 'Бардык жанрдагы мыкты Android оюндары! Жүктөп алыңыз жана оюндардын жаңы дүйнөсүн табыңыз',
    'Войти': 'Кирүү',
    'Номер телефона': 'Телефон номуру',
    'Пароль': 'Купуя сөз',
    'Ошибка, повторите позже': 'Ката, кийинчерээк кайра аракет кылыңыз',
    'Личный кабинет': 'Жеке бөлмө',
    'Имя': 'Аты',
    'Ник': 'Ник',
    'Аватар': 'Аватар',
    'Изменить': 'Өзгөртүү',
    'Выбрать': 'Тандоо',
    'Настройки аватара': 'Аватар орнотуулары',
    'Отменить': 'Жокко чыгаруу',
    'Сохранить': 'Сактоо',
    'Данные сохранены': 'Дайындар сакталды',
    'Не все данные заполнены': 'Бардык маалыматтар толтурулган эмес',
    'Вы не подписаны, подпишитесь': 'Сиз жазылган эмессиз, жазылыңыз',
    'Команда подключения': 'Байланыш буйругу',
    'Загрузить еще': 'Көбүрөөк жүктөө',
    'Все': 'Бардыгы',
    'Казуальные': 'Кокус',
    'Детские': 'Бала',
    'Гонки': 'Жарыш',
    'Экшен': 'Аракет',
    'Симулятор': 'Симулятор',
    'Раннер': 'Runner',
    'Азартные': 'Кумар',
    'Стрелялки': 'Атуучу',
    'Аркады': 'Аркада',
    'Спорт': 'Спорт',
    'Логические': 'Мээ ойноо',
    'Новинки': 'Жаңы',
    'Популярное': 'Популярдуу',
    'Онлайн Игры': 'Онлайн оюндар',
    'Android Игры': 'Android оюндары',
}
